export const BENCHMARK_LEADS_PATH = '/pga-coach/leads'

export const COACH_BENCHMARKS_PATH = '/pga-coach/benchmarks'
export const BENCHMARK_METRIC_QUERY_PARAM = 'metric'

export const getCoachBenchmarksPath = (metricId = null) =>
  metricId
    ? `${COACH_BENCHMARKS_PATH}?${BENCHMARK_METRIC_QUERY_PARAM}=${metricId}`
    : COACH_BENCHMARKS_PATH

export const getMetricCalculationDescription = metric =>
  metric.calculationDescription ?? metric.description

export const parseBenchmarkMetricId = search =>
  new URLSearchParams(search).get(BENCHMARK_METRIC_QUERY_PARAM)

export const COACH_DASHBOARD_PATH = '/pga-coach'

export const BENCHMARK_PEER_LABEL = 'Top coaches'

export const BENCHMARK_CARD_SUBTITLE =
  'Review your performance compared to top lesson coaches on PGA Coach.'
